import {
  AppStateDevicesState,
  Device,
  DeviceData,
  DeviceFilter,
  DeviceResidentDTO,
  DeviceSocketUpdateDTO,
  DevicesSortType,
  DeviceType,
} from ".";
import { HEALTH_CHECK } from "../healthCheck/types";
import { MoveResidentWithDevicesBySocketDTO } from "../residents";
import { RESIDENTS } from "../residents/types";
import { SortDirection } from "../types";
import { DeviceUserDTO } from "../users";
import { USERS, UsersActionType } from "../users/types";
import {
  DeviceActionType,
  DEVICES,
  IAddDeviceBySocket,
  IChangeUserNearbyAlertSettingsBySocket,
  IDeleteDeviceBySocket,
  IGetOneDevicesSuccess,
  ISetDevicesSettings,
  IUpdateDeviceBySocket,
} from "./types";

const initialState: AppStateDevicesState = {
  devices: {},
  isLoading: false,
  roomBedChangeSuccess: undefined,
  settingsVitals: {
    searchValue: "",
    sort: { direction: SortDirection.ASC, type: DevicesSortType.Id },
    selectedDevices: [],
    filters: {
      [DeviceFilter.ACTIVE]: false,
      [DeviceFilter.NOT_ACTIVE]: false,

      [DeviceFilter.RESIDENT_YES]: false,
      [DeviceFilter.RESIDENT_NO]: false,
      [DeviceFilter.ROOM_BED_YES]: false,
      [DeviceFilter.ROOM_BED_NO]: false,
      [DeviceFilter.UNPLUGGED]: false,
      [DeviceFilter.MAINTENANCE]: false,
      [DeviceFilter.BatteryLevelLow]: false,
      [DeviceFilter.BatteryLevelEmpty]: false,
      [DeviceFilter.LOW_WIFI]: false,
      [DeviceFilter.NO_WIFI]: false,
      [DeviceFilter.PUMP_YES]: false,
      [DeviceFilter.PUMP_NO]: false,
      [DeviceFilter.PIR_YES]: false,
      [DeviceFilter.PIR_NO]: false,
      [DeviceFilter.TURN_OFF]: false,
      [DeviceFilter.USER_NEARBY_IN_BED]: false,
      [DeviceFilter.USER_NEARBY_OUT_BED]: false,
      [DeviceFilter.USER_NEARBY_ROOM]: false,
    },
  },
  settingsBiopatch: {
    searchValue: "",
    sort: { direction: SortDirection.ASC, type: DevicesSortType.Id },
    selectedDevices: [],
    filters: {
      [DeviceFilter.ACTIVE]: false,
      [DeviceFilter.NOT_ACTIVE]: false,
      [DeviceFilter.RESIDENT_YES]: false,
      [DeviceFilter.RESIDENT_NO]: false,
      [DeviceFilter.BatteryLevelLow]: false,
      [DeviceFilter.BatteryLevelEmpty]: false,
      [DeviceFilter.MAINTENANCE]: false,
      [DeviceFilter.NO_BLUETOOTH]: false,
    },
  },
  settingsWatch: {
    searchValue: "",
    sort: { direction: SortDirection.ASC, type: DevicesSortType.Id },
    selectedDevices: [],
    filters: {
      [DeviceFilter.ACTIVE]: false,
      [DeviceFilter.NOT_ACTIVE]: false,
      [DeviceFilter.RESIDENT_YES]: false,
      [DeviceFilter.RESIDENT_NO]: false,
      [DeviceFilter.BatteryLevelLow]: false,
      [DeviceFilter.BatteryLevelEmpty]: false,
    },
  },
  settingsUserTag: {
    searchValue: "",
    sort: { direction: SortDirection.ASC, type: DevicesSortType.Id },
    selectedDevices: [],
    filters: {
      [DeviceFilter.ACTIVE]: false,
      [DeviceFilter.NOT_ACTIVE]: false,
      [DeviceFilter.RESIDENT_YES]: false,
      [DeviceFilter.RESIDENT_NO]: false,
      [DeviceFilter.BatteryLevelLow]: false,
      [DeviceFilter.BatteryLevelEmpty]: false,
    },
  },
};

const reducer = (
  state = initialState,
  action: DeviceActionType | UsersActionType
): AppStateDevicesState => {
  switch (action.type) {
    case HEALTH_CHECK.NEED_TO_NOTIFY_LOGIN: {
      return initialState;
    }
    case DEVICES.GET_DEVICES_SUCCESS: {
      const items = action.payload;
      const mappedDevices: DeviceData = { ...state.devices };
      items.forEach((el: any) => {
        const { node, resident, self, room, bed, ...rest } = el;
        const device: Device = {
          ...rest,
          id: self.id,
          nodeId: Number.parseInt(node.id),
          residentId: resident !== null ? resident.id : undefined,
          room: room !== null ? room : undefined,
          bed: bed !== null ? bed : undefined,
        };
        if (mappedDevices[self.id])
          mappedDevices[self.id] = {
            ...mappedDevices[self.id],
            ...device,
          };
        else mappedDevices[self.id] = device;
      });

      return {
        ...state,
        devices: { ...state.devices, ...mappedDevices },
        isLoading: false,
      };
    }

    case DEVICES.GET_ONE_DEVICE_SUCCESS: {
      const { device } = (action as IGetOneDevicesSuccess).payload;
      // const deviceKey: string = state.devices.find((el) => el.id === device.id);
      const devices = { ...state.devices, [device.id]: device };
      // devices.splice(devices.indexOf(wasDevice), 1, {
      //     ...wasDevice,
      //     room: device.room,
      //     bed: device.bed,
      //     hasPump: device.hasPump,
      // });
      return { ...state, devices: devices, isLoading: false };
    }

    case DEVICES.MOVE_RESIDENT_WITH_DEVICES_SUCCESS: {
      const data = action.payload;
      const mapedDevices = {} as DeviceData;
      if (Array.isArray(data)) {
        data.map((el) => {
          const currDevice = state.devices[el.id];
          if (currDevice && currDevice.nodeId !== el.resourceNodeId)
            mapedDevices[currDevice.id] = {
              ...currDevice,
              nodeId: el.resourceNodeId,
            };
          return null;
        });
        if (Object.keys(mapedDevices).length > 0)
          return {
            ...state,
            devices: { ...state.devices, ...mapedDevices },
            isLoading: false,
          };
      }
      return { ...state, isLoading: false };
    }

    case RESIDENTS.DELETE_RESIDENT_BY_SOCKET: {
      const data = action.payload;
      const index = Object.values(state.devices).findIndex(
        (device) => device?.residentId === data.id
      );

      if (index === -1) return state;
      const device = state.devices[index];
      if (!device) return state;
      device.residentId = undefined;
      return { ...state, devices: { ...state.devices } };
    }

    case RESIDENTS.DELETE_DEVICE_FROM_RESIDENT_BYSOCKET: {
      const data: DeviceResidentDTO = action.payload;
      const device = state.devices[data.deviceId];
      if (device && device?.residentId === data?.residentId) {
        return {
          ...state,
          devices: {
            ...state.devices,
            [device.id]: { ...device, residentId: undefined },
          },
        };
      }
      return state;
    }
    case RESIDENTS.ADD_DEVICE_TO_RESIDENT_BY_SOCKET: {
      const data: DeviceResidentDTO = action.payload;
      const device = state.devices[data.deviceId];
      if (device) {
        return {
          ...state,
          devices: {
            ...state.devices,
            [device.id]: { ...device, residentId: data?.residentId },
          },
        };
      }
      return state;
    }
    case DEVICES.UPDATE_DEVICE_BY_SOCKET: {
      const data: DeviceSocketUpdateDTO = (action as IUpdateDeviceBySocket)
        .payload;
      const wasDevice = state.devices[data.id];
      if (wasDevice) {
        const { id, resident, nodeId, type, room, bed, ...rest } = data;
        const shouldRemoveRAndB =
          nodeId !== wasDevice.nodeId && type === DeviceType.vitals;
        return {
          ...state,
          devices: {
            ...state.devices,
            [data.id]: {
              ...wasDevice,
              ...rest,
              nodeId: nodeId,
              room: shouldRemoveRAndB
                ? undefined
                : room === null
                ? undefined
                : room,
              bed: shouldRemoveRAndB
                ? undefined
                : bed === null
                ? undefined
                : bed,
              residentId: resident === null ? undefined : resident,
            },
          },
        };
      }
      return state;
    }
    case DEVICES.ADD_DEVICE_BY_SOCKET: {
      const data: DeviceSocketUpdateDTO = (action as IAddDeviceBySocket)
        .payload;

      return {
        ...state,
        devices: {
          ...state.devices,
          [data.id]: {
            ...data,
            nodeId: data?.nodeId,
            residentId: data?.resident !== null ? data?.resident : undefined,
            room: data?.room !== null ? data?.room : undefined,
            bed: data?.bed !== null ? data?.bed : undefined,
          },
        },
      };
    }
    case DEVICES.DELETE_DEVICE_BY_SOCKET: {
      const data: DeviceResidentDTO = (action as IDeleteDeviceBySocket).payload;
      delete state.devices[data.deviceId];
      return {
        ...state,
        devices: {
          ...state.devices,
        },
      };
    }
    case RESIDENTS.MOVE_RESIDENT_WITH_DEVICES_BY_SOCKET: {
      const data = action.payload as MoveResidentWithDevicesBySocketDTO;
      if (Array.isArray(data.deviceIds)) {
        const mapedDevices = {} as DeviceData;
        data.deviceIds.map((id) => {
          const curruntDevice = state.devices[id];
          if (curruntDevice && curruntDevice.nodeId !== data.toNodeId) {
            mapedDevices[curruntDevice.id] = {
              ...curruntDevice,
              nodeId: data.toNodeId,
            };
          }
          return null;
        });
        return { ...state, devices: { ...state.devices, ...mapedDevices } };
      }
      return state;
    }

    case DEVICES.GET_DEVICES_REQUEST: {
      const { blocking } = action.payload;
      return blocking ? { ...state, isLoading: true } : state;
    }
    case RESIDENTS.MOVE_RESIDENT_WITH_DEVICES_FAILURE:
    case DEVICES.GET_DEVICES_FAILURE:
    case DEVICES.GET_ONE_DEVICE_FAILURE:
    case DEVICES.MOVE_MANY_DEVICE_FAILURE: {
      return { ...state, isLoading: false };
    }
    case DEVICES.SET_SETTINGS: {
      const { type, value } = (action as ISetDevicesSettings).payload;
      switch (type) {
        case DeviceType.vitals:
          return {
            ...state,
            settingsVitals: { ...state.settingsVitals, ...value },
          };
        case DeviceType.biopatch:
          return {
            ...state,
            settingsBiopatch: { ...state.settingsBiopatch, ...value },
          };
        case DeviceType.watch:
          return {
            ...state,
            settingsWatch: { ...state.settingsWatch, ...value },
          };
        case DeviceType.userTag:
          return {
            ...state,
            settingsUserTag: { ...state.settingsUserTag, ...value },
          };
      }
      return state;
    }
    case DEVICES.CHANGE_SELECTED: {
      const { type, value } = action.payload;
      let selected = [];
      switch (type) {
        case DeviceType.vitals:
          selected = [...state.settingsVitals.selectedDevices];
          break;
        case DeviceType.biopatch:
          selected = [...state.settingsBiopatch.selectedDevices];
          break;
        case DeviceType.watch:
          selected = [...state.settingsWatch.selectedDevices];
          break;
        case DeviceType.userTag:
          selected = [...state.settingsUserTag.selectedDevices];
          break;
      }

      if (selected.indexOf(value) === -1) selected.push(value);
      else selected.splice(selected.indexOf(value), 1);
      switch (type) {
        case DeviceType.vitals:
          return {
            ...state,
            settingsVitals: {
              ...state.settingsVitals,
              selectedDevices: selected,
            },
          };
        case DeviceType.biopatch:
          return {
            ...state,
            settingsBiopatch: {
              ...state.settingsBiopatch,
              selectedDevices: selected,
            },
          };
        case DeviceType.watch:
          return {
            ...state,
            settingsWatch: {
              ...state.settingsWatch,
              selectedDevices: selected,
            },
          };
        case DeviceType.userTag:
          return {
            ...state,
            settingsUserTag: {
              ...state.settingsUserTag,
              selectedDevices: selected,
            },
          };
      }
      return state;
    }

    case DEVICES.CHANGE_DEVICE_REQUEST: {
      return { ...state, roomBedChangeSuccess: undefined };
    }
    case DEVICES.CHANGE_DEVICE_SUCCESS: {
      return { ...state, roomBedChangeSuccess: true };
    }
    case DEVICES.CHANGE_DEVICE_FAILURE: {
      return { ...state, roomBedChangeSuccess: false, isLoading: false };
    }

    case DEVICES.CLEAR_SUCCESS_STATE: {
      return { ...state, roomBedChangeSuccess: undefined };
    }
    case USERS.DELETE_DEVICE_FROM_USER_BYSOCKET: {
      const data: DeviceUserDTO = action.payload;
      const device = state.devices[data.deviceId];
      if (device && device.userId === data.id) {
        return {
          ...state,
          devices: {
            ...state.devices,
            [device.id]: { ...device, userId: undefined },
          },
        };
      }
      return state;
    }
    case USERS.ADD_DEVICE_TO_USER_BY_SOCKET: {
      const data: DeviceUserDTO = action.payload;
      const device = state.devices[data.deviceId];
      if (device) {
        return {
          ...state,
          devices: {
            ...state.devices,
            [device.id]: {
              ...device,
              userId: data.id,
              nodeId: parseInt(data.nodeId),
            },
          },
        };
      }
      return state;
    }
    case DEVICES.GET_USER_TAG_DEVICES_SUCCESS: {
      const res = action.payload;
      const mapped = { ...state.devices };
      res.map((el) => {
        const dev: Device = {
          id: el?.productId,
          mac: el?.macId,
          ...el,
          userId: el?.userId || undefined,
          type: DeviceType.userTag,
        };
        mapped[el?.productId] = dev;
        return null;
      });
      return { ...state, devices: mapped };
    }
    case DEVICES.CHANGE_USER_NEARBY_ALERT_SETTINGS_BY_SOCKET: {
      const { deviceId, continuesDetectionTime } = (
        action as IChangeUserNearbyAlertSettingsBySocket
      ).payload;
      const wasDevice = state.devices[deviceId];
      if (wasDevice)
        return {
          ...state,
          devices: {
            ...state.devices,
            [deviceId]: {
              ...wasDevice,
              continuesDetectionTime: continuesDetectionTime,
            },
          },
        };
      return state;
    }
    default:
      return state;
  }
};
export default reducer;
